import ProfileImage from "../../../components/profile/ProfileImage";
import {useContext, useEffect, useMemo, useState} from "react";
import FlexBox from "../../../components/utilities/FlexBox";
import TableHead from "../../../components/utilities/table/TableHead";
import PageLayout from "../../../layout/page-layout/PageLayout";
import Table from "../../../components/utilities/table/Table";
import PencilIcon from '../../../assets/candidate-profile/PencilIcon.svg';
import DeleteIcon from '../../../assets/candidate-profile/DeleteIcon.svg';
import HoverPencilIcon from '../../../assets/candidate-profile/HoverPencilIcon.svg';
import HoverDeleteIcon from '../../../assets/candidate-profile/HoverDeleteIcon.svg';
import EditCandidateIcon from '../../../assets/candidate-profile/editCandidate.svg';
import DeleteCandidateIcon from '../../../assets/candidate-profile/deleteCandidate.svg';
import DateMobileIcon from '../../../assets/dashboard/dataMobile.svg';
import SearchCandidatesIcon from '../../../assets/candidate-profile/searchCandidates.svg';
import EditButton from "../candidate-id/edit-button/EditButton";
import DeleteButton from "../candidate-id/delete-button/DeleteButton";
import './CandidatesList.css'
import axios from "axios";
import {
    getCandidateFullName, getUrlParameter
} from "../../../utilities/Utilities";
import {
    API_URL_PREFIX,
    APP_URL_PREFIX,
} from "../../../utilities/Constants";
import Loader from "../../../components/utilities/Loader";
import {
    CustomErrorToast,
    CustomLoadingToast,
    updateCustomErrorToast,
    updateCustomSuccessToast
} from "../../../components/utilities/CustomToast";
import {Button} from "react-bootstrap";
import SendTest,{SendTestsCSV} from "../../../components/send-test/SendTest";
import SendTestInvitation from '../candidate-id/send-test-invitation-button/SendTestInvitation';
import {Pencil, X} from "react-bootstrap-icons";
import ConfirmModal from "../../../components/utilities/ConfirmModal";
import SearchBar from "../../../components/search/SearchBar";
import {Link, useNavigate} from "react-router-dom";
import CompanyTeamContext from "../../../CompanyTeamContext";
import Pagination from "../../../components/utilities/Pagination";
import GradientButton from "../../../components/utilities/gradient-button/GradientButton";
import ReactTooltip from 'react-tooltip';

const PAGE_SIZE = 10;

const CandidatesList = () => {
    const [candidates, setCandidates] = useState()
    const [page, setPage] = useState(0)
    const [totalCandidates, setTotalCandidates] = useState(0)
    const [keyword, setKeyword] = useState(getUrlParameter("kw") || "")
    const [searchMode, setSearchMode] = useState(false)
    const [loader, setLoader] = useState(true)
    const [showCSV, setShowCSV] = useState(false)
    const company = useContext(CompanyTeamContext)
    let sentTestsQuota = 0;
    if(company){
        sentTestsQuota = company.sentTestsQuota
    }

    useEffect(() => {
        return () => {
            setPage(0)
        }
    }, []);

    useEffect(()=>{
        if(!searchMode){
            // go back to normal pagination mode
            countCandidates();
            getAllCandidates(true);
        }

    }, [searchMode]);

    const countCandidates = () => {
        if(searchMode) return;
        setLoader(true)
        axios.get(  API_URL_PREFIX+"/CountCandidates.html")
            .then(response => {
                setLoader(false)
                debugger;
                let cands = response.data.count || 0
                setTotalCandidates(cands)
            })
            .catch(e => {
                setLoader(false)
                if(e.response.status == 403){
                    CustomErrorToast("Permission Denied!")
                }
                else{
                    CustomErrorToast("Error fetching tests, Please try again.")
                }
            })
    }

    const getCandidates = (limit, offset, keyword, searchMode = false) => {
        const sentPage = page + ''
        setLoader(true)

        let url = API_URL_PREFIX+"/GetAllCandidates.html";
        if(!keyword && limit !== undefined && offset !== undefined){
            url += "?limit="+limit+"&offset="+offset
        }
        if(keyword){
            url += (url.includes("?") ? "&" : "?") + "keyword="+encodeURIComponent(keyword)
        }
        axios.get(  url)
            .then(response => {
                setLoader(false)
                if(!searchMode && sentPage !== page + '') {
                    return; // If the page has changed while fetching, ignore this response
                }
                let cands = response.data || []
                cands = cands.sort((a,b)=>{
                    return b.lastModified - a.lastModified
                })
                setCandidates(cands)


                if(searchMode){
                    setTotalCandidates(cands.length)
                }

            })
            .catch(e => {
                setLoader(false)
                if(e.response.status == 403){
                    CustomErrorToast("Permission Denied!")
                }
                else{
                    CustomErrorToast("Error fetching tests, Please try again.")
                }
            })
    }

    const getAllCandidates = (refresh) =>{
        if(company && (refresh || !candidates)) {
            getCandidates(PAGE_SIZE, page * PAGE_SIZE, keyword);
        }
        else {
            setLoader(false)
        }
    }

    useEffect(() => {
        if(searchMode) return;
        getAllCandidates(true)},
        [page]);

    useEffect(()=>{

        if(company){
            document.title  = "Candidates List - " + company.basicTitle
            return () => {
                document.title = company.basicTitle
            }
        }

        if(!searchMode){
            countCandidates();
            getAllCandidates();
        }


        return () => {
            setPage(0)
        }
    }, [company])

    let filteredList  = (candidates || []);

    const search = e=>{
        if(!keyword || keyword.length < 3){
            CustomErrorToast("Please enter at least 3 characters to search.")
        }
        else {
            setSearchMode(true)
            setPage(0);
            getCandidates(undefined, undefined, keyword, true);
        }
    }
    
    
    return (<PageLayout height={"100%"} pageClassName="candidates-list-page-wrapper">
        {showCSV ? <SendTestsCSV refreshCandidates={getAllCandidates} setShow={setShowCSV}/> : ""}

        {/* Desktop Layout */}
        <div className="candidates-desktop" style={{
            justifyContent: "top", display: "flex",height:"100%", width: "100%", flexDirection: "column", padding: "30px"
        }}
             justify={"top"}>
            <FlexBox style={{width:"100%"}} justify={"space-between"}>
                <h3 style={{color: "#364454", fontWeight: "700", fontSize: "20px"}}>Candidates List</h3>
                <div className="candidates-desktop-search-container">
                    <div className="candidates-desktop-search-wrapper">
                        {keyword && (
                            <button
                                className="candidates-desktop-search-clear"
                                onClick={() => {
                                    setSearchMode(false);
                                    setKeyword("");
                                }}
                            >
                                ✕
                            </button>
                        )}
                        <input
                            className="candidates-desktop-search-input"
                            value={keyword}
                            onChange={e=>setKeyword(e.target.value)}
                            placeholder="Search by Name or Email"
                            onKeyDown={e => {
                                if (e.key === 'Enter') {
                                    search();
                                }
                            }}
                        />
                        <button
                            className="candidates-desktop-search-button"
                            onClick={search}
                        >
                            <img src={SearchCandidatesIcon} alt="Search" />
                        </button>
                    </div>
                </div>
                <Button hidden={!sentTestsQuota} onClick={()=>setShowCSV(!showCSV)}>Send Tests - CSV</Button>
            </FlexBox>
            <br/>
            <div className={"table-wrapper"}>
                <Table id={"candidatesTable"}>
                    <TableHead columns={["", "Name", "E-Mail", "Last Modified","","",""]}/>
                    <TableBody setCandidates={setCandidates} candidates={filteredList} loader={loader} keyword={keyword} page={page}/>
                </Table>
            </div>
			<FlexBox justify={"space-between"} align={"end"}>
                <div style={{
                    marginTop: "10px",
                    fontSize: "12px",
                    textAlign: "left"
                }}>{totalCandidates} Candidates
                </div>
                <Pagination currentPage={page} onPageChange={setPage}
                            totalPages={Math.ceil(totalCandidates / PAGE_SIZE)} style={{marginTop: "10px"}}/>

            </FlexBox>
        </div>

        {/* Mobile Layout */}
        <FlexBox className="candidates-mobile" style={{display: "none", flexDirection: "column", width: "100%"}}>
            <ReactTooltip className="candidates-mobile-tooltip" multiline place="top" type="dark" effect="solid" />

            <h3 className="candidates-mobile-title" style={{color: "#364454", fontWeight: "700", fontSize: "20px", marginBottom: "20px"}}>Candidates List</h3>

            <div className="candidates-mobile-search-container">
                <div className="candidates-mobile-search-wrapper">
                    {keyword && (
                        <button
                            className="candidates-mobile-search-clear"
                            onClick={() => {
                                setSearchMode(false);
                                setKeyword("");
                            }}
                        >
                            ✕
                        </button>
                    )}
                    <input
                        className="candidates-mobile-search-input"
                        value={keyword}
                        onChange={e=>setKeyword(e.target.value)}
                        placeholder="Search by Name or Email"
                        onKeyDown={e => {
                            if (e.key === 'Enter') {
                                search();
                            }
                        }}
                    />
                    <button
                        className="candidates-mobile-search-button"
                        onClick={search}
                    >
                        <img src={SearchCandidatesIcon} alt="Search" />
                    </button>
                </div>
            </div>

            <MobileTableBody setCandidates={setCandidates} candidates={filteredList} loader={loader} page={page}/>

            <FlexBox className="candidates-mobile-footer" justify={"space-between"} align={"center"} style={{padding: "0 5vw", marginTop: "20px"}}>
                <div style={{fontSize: "12px", textAlign: "left"}}>{totalCandidates} Candidates</div>
                <Pagination currentPage={page} onPageChange={setPage}
                            totalPages={Math.ceil(totalCandidates / PAGE_SIZE)} style={{marginTop: "10px"}}/>
            </FlexBox>
        </FlexBox>
    </PageLayout>)
}




function TableBody({candidates, setCandidates, loader, page}) {
    return (<tbody>

    <Loader loader={loader}/>
    { !loader && (!candidates || candidates.length == 0)
        && <tr><td style={{verticalAlign:"middle", color:"#bababa", textAlign:"center"}} rowSpan={5} colSpan={6}>No Candidates Found.</td></tr> }
    {candidates.map((c, i) => <CandidateRow key={c.key} setCandidates={setCandidates} candidate={c} index={page * PAGE_SIZE + i} />)}
    </tbody>);
}


function CandidateRow({candidate, index, setCandidates}) {

    const [sendTest, setSendTest] = useState(false)
    const [showConfirmDelete, setShowConfirmDelete ] = useState(false)
    const [submitted, setSubmitted] = useState(false)
    const navigate = useNavigate();

    const deleteCandidate = ()=>{

        const id = CustomLoadingToast("Deleting...")
        axios.delete(API_URL_PREFIX+"/DeleteCandidate.html?id="+candidate.key)
        .then(e=>{
            let data = e.data;
            if(data && !data.err){
                setCandidates(candidates=>candidates.filter(e=>e.key!=candidate.key))
                updateCustomSuccessToast("Deleted",id)
            }
            else{
                updateCustomErrorToast(data.info,id)
            }
            setShowConfirmDelete(false)
        })
        .catch(err=>{
            setShowConfirmDelete(false)
            updateCustomErrorToast("Error, Please try again",id)
            console.log(err)
        })
    }

    return <tr className={"candidate-body"}
               style={{height: "40px", textAlign: "left", verticalAlign: "middle"}}>
        <td style={{width: "50px", textAlign: "center", color:"#bababa"}}>{+index + 1}</td>
        <td><ProfileImage name={getCandidateFullName(candidate)} width="40px" height="40px" fontSize="16px" /> <Link className={"candidate-link"} to={APP_URL_PREFIX+"/candidate/" + candidate.key}>&nbsp;{getCandidateFullName(candidate)}</Link>
        </td>
        <td>{candidate.email}</td>
        <td>{new Date(candidate.lastModified).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</td>
        <td style={{position: "relative"}}>
            <SendTestInvitation onClick={e => setSendTest(true)} />
        </td>
        <td>
        	<EditButton onClick={() => (navigate(APP_URL_PREFIX+"/candidate/" + candidate.key + "/edit"))} label="Edit" icon={PencilIcon} hoverIcon={HoverPencilIcon}/>
        </td>
        <td>
        <DeleteButton onClick={() => setShowConfirmDelete(true)} label="Delete" icon={DeleteIcon} hoverIcon={HoverDeleteIcon}/>

        </td>


        {sendTest && <SendTest candidate={candidate} setShow={setSendTest} submitted={submitted} setSubmitted={setSubmitted} />}
        {showConfirmDelete && <ConfirmModal variant={"danger"} show={showConfirmDelete} setShow={setShowConfirmDelete} callback={deleteCandidate} body={"Are you sure you want to delete "+getCandidateFullName(candidate)+"?"} title={"Confirm Delete"} yes={"Delete"} no={"Cancel"} fallback={e=>setShowConfirmDelete(false)}  />}
    </tr>;
}


// Mobile Components
function MobileTableBody({candidates, setCandidates, loader, page}) {
    useEffect(() => {
        if (candidates && candidates.length > 0) {
            setTimeout(() => ReactTooltip.rebuild(), 100);
        }
    }, [candidates]);

    return (
        <div className="candidates-mobile-cards">
            <Loader loader={loader}/>
            {!loader && (!candidates || candidates.length === 0) && (
                <div style={{textAlign: "center", color: "#bababa", padding: "20px"}}>
                    No Candidates Found.
                </div>
            )}
            {candidates && candidates.map((c, i) => (
                <MobileCandidateCard
                    key={c.key}
                    setCandidates={setCandidates}
                    candidate={c}
                    index={page * PAGE_SIZE + i}
                />
            ))}
        </div>
    );
}

function MobileCandidateCard({candidate, setCandidates}) {
    const [sendTest, setSendTest] = useState(false);
    const [showConfirmDelete, setShowConfirmDelete] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const navigate = useNavigate();

    const deleteCandidate = () => {
        const id = CustomLoadingToast("Deleting...");
        axios.delete(API_URL_PREFIX + "/DeleteCandidate.html?id=" + candidate.key)
            .then(e => {
                let data = e.data;
                if (data && !data.err) {
                    setCandidates(candidates => candidates.filter(e => e.key != candidate.key));
                    updateCustomSuccessToast("Deleted", id);
                } else {
                    updateCustomErrorToast(data.info, id);
                }
                setShowConfirmDelete(false);
            })
            .catch(err => {
                setShowConfirmDelete(false);
                updateCustomErrorToast("Error, Please try again", id);
                console.log(err);
            });
    };

    return (
        <div className="candidate-mobile-card">
            <div className="candidate-mobile-card-top">
                <ProfileImage name={getCandidateFullName(candidate)} />
                <div className="candidate-mobile-card-info">
                    <Link className="candidate-mobile-card-name" to={APP_URL_PREFIX + "/candidate/" + candidate.key}>
                        {getCandidateFullName(candidate)}
                    </Link>
                    <div className="candidate-mobile-card-email">{candidate.email}</div>
                </div>
                <button className="candidate-mobile-menu-button" onClick={() => setShowMenu(!showMenu)}>
                    ⋮
                </button>
            </div>

            <div className="candidate-mobile-card-divider"></div>

            <div className="candidate-mobile-card-bottom">
                <div className="candidate-mobile-card-date-container" data-tip="Last Modified">
                    <img src={DateMobileIcon} alt="Date" />
                    <span className="candidate-mobile-card-date">
                        {new Date(candidate.lastModified).toLocaleDateString('en-US', {
                            month: 'short',
                            day: 'numeric',
                            year: 'numeric'
                        })}
                    </span>
                </div>
                <SendTestInvitation onClick={e => setSendTest(true)} />
            </div>

            {showMenu && (
                <>
                    <div className="candidate-menu-backdrop" onClick={() => setShowMenu(false)}></div>
                    <div className="candidate-menu-popup">
                        <div className="candidate-menu-content">
                            <button
                                className="candidate-menu-item candidate-menu-edit"
                                onClick={() => {
                                    navigate(APP_URL_PREFIX + "/candidate/" + candidate.key + "/edit");
                                    setShowMenu(false);
                                }}
                            >
                                <img src={EditCandidateIcon} alt="Edit" style={{width: '18px', height: '18px'}} />
                                <span>Edit</span>
                            </button>
                            <button
                                className="candidate-menu-item candidate-menu-delete"
                                onClick={() => {
                                    setShowConfirmDelete(true);
                                    setShowMenu(false);
                                }}
                            >
                                <img src={DeleteCandidateIcon} alt="Delete" style={{width: '18px', height: '18px'}} />
                                <span>Delete</span>
                            </button>
                        </div>
                    </div>
                </>
            )}

            {sendTest && <SendTest candidate={candidate} setShow={setSendTest} submitted={submitted} setSubmitted={setSubmitted} />}
            {showConfirmDelete && (
                <ConfirmModal
                    variant={"danger"}
                    show={showConfirmDelete}
                    setShow={setShowConfirmDelete}
                    callback={deleteCandidate}
                    body={"Are you sure you want to delete " + getCandidateFullName(candidate) + "?"}
                    title={"Confirm Delete"}
                    yes={"Delete"}
                    no={"Cancel"}
                    fallback={e => setShowConfirmDelete(false)}
                />
            )}
        </div>
    );
}


export default CandidatesList